(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.getElementById('mpb-root');
    if (!root || root.getAttribute('data-enabled') !== 'true') return;

    var packsBySize = {};
    try {
      var packsNode = document.getElementById('mpb-packs-json');
      var raw = packsNode ? packsNode.textContent : root.getAttribute('data-packs') || '{}';
      packsBySize = JSON.parse(raw || '{}') || {};
    } catch (e) {
      packsBySize = {};
    }

    var defaultPack = Number(root.getAttribute('data-default-size') || 12) || 12;
    var packVariantId = Number(root.getAttribute('data-pack-variant-id') || 0);
    var priceDisplay = root.getAttribute('data-price-display') || '';

    var grid = document.getElementById('mpb-grid');
    var packSizeSel = document.getElementById('mpb-pack-size');
    var searchInput = document.getElementById('mpb-search');
    var slotsEl = document.getElementById('mpb-slots');
    var dockSlotsEl = document.getElementById('mpb-dock-slots');
    var progressEls = document.querySelectorAll('[data-mpb-progress]');
    var barFill = document.getElementById('mpb-bar-fill');
    var addBtns = document.querySelectorAll('[data-mpb-add]');
    var msgEls = document.querySelectorAll('[data-mpb-msg]');
    var neededEls = document.querySelectorAll('[data-mpb-needed]');
    var priceEls = document.querySelectorAll('[data-mpb-price]');
    var emptyEl = document.getElementById('mpb-search-empty');
    var hintEls = document.querySelectorAll('.mpb-hint');

    if (!grid || !slotsEl) return;

    // Snapshot the Liquid-rendered pool so we can restore after search clears
    var poolHtml = grid.innerHTML;
    var productCache = {};
    var searchTimer = 0;
    var searchSeq = 0;
    var slotSeq = 1;

    /** @type {{uid:number, vid:number, title:string, img:string}[]} */
    var order = [];
    var packLimit = defaultPack;

    function moneyLabel(centsOrString) {
      if (centsOrString == null || centsOrString === '') return '';
      if (typeof centsOrString === 'string' && centsOrString.indexOf('$') === 0) return centsOrString;
      var n = Number(centsOrString);
      if (!Number.isFinite(n)) return String(centsOrString);
      if (n >= 100 && Number.isInteger(n) && String(centsOrString).indexOf('.') === -1) n = n / 100;
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n);
      } catch (e) {
        return '$' + n.toFixed(2);
      }
    }

    function escapeAttr(s) {
      return String(s || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function applySize(size) {
      size = Number(size) || defaultPack;
      packLimit = size;
      var info = packsBySize[String(size)] || packsBySize[size] || null;
      if (info) {
        if (info.id) packVariantId = Number(info.id);
        if (info.price != null) priceDisplay = moneyLabel(info.price);
      }
      root.setAttribute('data-pack-variant-id', String(packVariantId || ''));
      root.setAttribute('data-price-display', priceDisplay || '');
      priceEls.forEach(function (el) {
        el.textContent = priceDisplay || '—';
      });
      var pill = root.querySelector('[data-mpb-price-pill] em');
      if (pill) pill.textContent = priceDisplay || '—';

      while (order.length > packLimit) order.pop();
      renderSlots();
      syncCards();
      syncButtonState();
      syncHint();
    }

    function setMessages(text, kind) {
      msgEls.forEach(function (el) {
        el.textContent = text || '';
        el.classList.remove('is-error', 'is-ok');
        if (kind) el.classList.add(kind);
      });
    }

    function syncHint() {
      var size = packLimit;
      var text =
        'Tap Add for multiples. Tap a sticker in your pack to remove it. Button shows 0/' +
        size +
        ' PACK until full, then ADD ' + size + ' PACK.';
      hintEls.forEach(function (el) {
        el.textContent = text;
      });
    }

    function addPackLabel(count, size, full) {
      if (full) return 'ADD ' + size + ' PACK';
      return count + '/' + size + ' PACK';
    }

    function syncButtonState() {
      var count = order.length;
      var full = count === packLimit && packLimit > 0;
      var label = addPackLabel(count, packLimit, full);
      addBtns.forEach(function (btn) {
        btn.disabled = !full;
        btn.textContent = label;
      });
      progressEls.forEach(function (el) {
        el.textContent = count + '/' + packLimit;
      });
      neededEls.forEach(function (el) {
        el.textContent = String(Math.max(0, packLimit - count));
      });
      if (barFill) {
        var pct = packLimit > 0 ? Math.min(100, (count / packLimit) * 100) : 0;
        barFill.style.width = pct + '%';
      }
    }

    function countVid(vid) {
      var n = 0;
      for (var i = 0; i < order.length; i++) if (order[i].vid === vid) n++;
      return n;
    }

    function renderSlots() {
      var html = '';
      var dockHtml = '';
      for (var i = 0; i < packLimit; i++) {
        var item = order[i];
        if (item) {
          html +=
            '<div class="mpb-slot is-filled" role="button" tabindex="0" data-uid="' +
            item.uid +
            '" data-vid="' +
            item.vid +
            '" title="Remove ' +
            escapeAttr(item.title) +
            '" aria-label="Remove ' +
            escapeAttr(item.title) +
            '">' +
            '<img src="' +
            escapeAttr(item.img) +
            '" alt="' +
            escapeAttr(item.title) +
            '" loading="lazy" draggable="false">' +
            '<button type="button" class="mpb-slot-remove" tabindex="-1" aria-hidden="true">×</button>' +
            '</div>';
          dockHtml +=
            '<div class="mpb-dock-slot is-filled" role="button" tabindex="0" data-uid="' +
            item.uid +
            '" title="Remove ' +
            escapeAttr(item.title) +
            '" aria-label="Remove ' +
            escapeAttr(item.title) +
            '"><img src="' +
            escapeAttr(item.img) +
            '" alt="" draggable="false"></div>';
        } else {
          html += '<div class="mpb-slot" aria-label="Empty slot ' + (i + 1) + '">' + (i + 1) + '</div>';
          dockHtml += '<div class="mpb-dock-slot"></div>';
        }
      }
      slotsEl.innerHTML = html;
      if (dockSlotsEl) dockSlotsEl.innerHTML = dockHtml;
    }

    function syncCards() {
      grid.querySelectorAll('.mpb-card').forEach(function (card) {
        var vid = Number(card.getAttribute('data-vid'));
        var n = countVid(vid);
        card.classList.toggle('is-selected', n > 0);
        var btn = card.querySelector('.mpb-select-btn');
        if (btn) {
          btn.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
          if (n <= 0) btn.textContent = 'Add';
          else if (n === 1) btn.textContent = 'Add another';
          else btn.textContent = 'Add another · ' + n;
        }
        var badge = card.querySelector('.mpb-qty');
        if (n > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'mpb-qty';
            card.appendChild(badge);
          }
          badge.textContent = '×' + n;
          badge.hidden = false;
        } else if (badge) {
          badge.hidden = true;
        }
      });
    }

    function addFromCard(card) {
      var vid = Number(card.getAttribute('data-vid'));
      if (!vid || packLimit <= 0) return;
      if (order.length >= packLimit) {
        setMessages('Pack is full — tap × on a slot to make room, or bump the pack size.', 'is-error');
        return;
      }
      order.push({
        uid: slotSeq++,
        vid: vid,
        title: card.getAttribute('data-title') || '',
        img: card.getAttribute('data-img') || ''
      });
      renderSlots();
      syncCards();
      syncButtonState();
      setMessages('', null);
    }

    function removeUid(uid) {
      uid = Number(uid);
      order = order.filter(function (item) {
        return item.uid !== uid;
      });
      renderSlots();
      syncCards();
      syncButtonState();
    }

    function pickVariant(product) {
      if (!product || !product.variants || !product.variants.length) return null;
      var i;
      var v;
      for (i = 0; i < product.variants.length; i++) {
        v = product.variants[i];
        var blob = ((v.title || '') + ' ' + (v.option1 || '') + ' ' + (v.option2 || '')).toLowerCase();
        if (blob.indexOf('hard hat') !== -1 || blob.indexOf('3"') !== -1 || blob.indexOf("3'") !== -1) {
          return v;
        }
      }
      for (i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available !== false) return product.variants[i];
      }
      return product.variants[0];
    }

    function fetchProduct(handle) {
      if (!handle) return Promise.resolve(null);
      if (productCache[handle]) return productCache[handle];
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('product ' + handle);
          return r.json();
        })
        .catch(function () {
          delete productCache[handle];
          return null;
        });
      return productCache[handle];
    }

    function cardHtml(item) {
      return (
        '<article class="mpb-card" data-vid="' +
        item.vid +
        '" data-title="' +
        escapeAttr(item.title) +
        '" data-search="' +
        escapeAttr(item.search || item.title) +
        '" data-img="' +
        escapeAttr(item.img) +
        '">' +
        '<button type="button" class="mpb-card-media" aria-label="Select ' +
        escapeAttr(item.title) +
        '">' +
        (item.img
          ? '<img src="' + escapeAttr(item.img) + '" alt="' + escapeAttr(item.title) + '" loading="lazy" width="360" height="360">'
          : '') +
        '</button>' +
        '<div class="mpb-card-body">' +
        '<button type="button" class="mpb-select-btn" aria-pressed="false">Add</button>' +
        '</div></article>'
      );
    }

    function showEmpty(show, msg) {
      if (!emptyEl) return;
      if (msg) emptyEl.textContent = msg;
      if (show) emptyEl.removeAttribute('hidden');
      else emptyEl.setAttribute('hidden', '');
    }

    function restorePool() {
      grid.innerHTML = poolHtml;
      showEmpty(false);
      syncCards();
    }


    function isExcludedProduct(p) {
      var blob = [
        p.title || '',
        p.handle || '',
        p.type || p.product_type || '',
        Array.isArray(p.tags) ? p.tags.join(' ') : p.tags || '',
        p.vtitle || ''
      ]
        .join(' ')
        .toLowerCase();

      if (/build your own|make your own|create your own|diy sticker/.test(blob)) return true;
      if (/\b(bulk|overruns?|over[\s-]?runs?)\b/.test(blob)) return true;
      if (/\b(mystery|variety)\s+pack\b/.test(blob)) return true;
      if (/\bpack of\b|\bsticker packs?\b|funny sticker packs/.test(blob)) return true;
      if (/(^|[\s\-_/])packs?([\s\-_/]|$)/.test(blob) && !/\bbackpack\b/.test(blob)) return true;
      // Customs / DIY only — do not drop normal stickers that mention "custom" in body copy
      if (/\b(custom text|custom sticker|create your own|diy)\b/.test(blob)) return true;
      if (/\bcustoms\b/.test(blob)) return true;
      if (/make-your-own|build-your-own|custom-text|mix-n-match|mix-and-match/.test(p.handle || '')) return true;
      return false;
    }

    function previewQuery() {
      try {
        var pt = new URLSearchParams(location.search).get('preview_theme_id');
        return pt ? '&preview_theme_id=' + encodeURIComponent(pt) : '';
      } catch (e) {
        return '';
      }
    }

    function searchUrl(q, page) {
      return (
        '/search?q=' +
        encodeURIComponent(q) +
        '&type=product&view=mpb&page=' +
        (page || 1) +
        previewQuery()
      );
    }

    function fetchSearchPage(q, page) {
      return fetch(searchUrl(q, page), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }).then(function (r) {
        if (!r.ok) throw new Error('search page ' + page);
        return r.text().then(function (text) {
          // Theme may wrap JSON; peel first { ... }
          var start = text.indexOf('{');
          var end = text.lastIndexOf('}');
          if (start === -1 || end === -1) throw new Error('bad search json');
          return JSON.parse(text.slice(start, end + 1));
        });
      });
    }

    function renderSearchItems(items, q) {
      if (!items.length) {
        grid.innerHTML = '';
        showEmpty(true, 'No single stickers match “' + q + '”. Try another word.');
        grid.removeAttribute('aria-busy');
        return;
      }
      var html = '';
      items.forEach(function (item) {
        html += cardHtml(item);
      });
      grid.innerHTML = html;
      showEmpty(false);
      syncCards();
      grid.removeAttribute('aria-busy');
    }

    function itemsFromMpbPages(pages) {
      var seen = {};
      var items = [];
      pages.forEach(function (page) {
        (page.products || []).forEach(function (p) {
          if (!p || !p.vid) return;
          if (isExcludedProduct(p)) return;
          var key = String(p.vid);
          if (seen[key]) return;
          seen[key] = 1;
          items.push({
            vid: p.vid,
            title: p.title || '',
            img: p.img || '',
            handle: p.handle || '',
            search: [p.title, p.type, (p.tags || []).join(' ')].join(' ')
          });
        });
      });
      return items;
    }

    function collectionHandleCandidates(q) {
      var base = String(q || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-');
      if (!base) return [];
      var known = {
        welder: ['welder-stickers-1', 'welder'],
        welders: ['welder-stickers-1', 'welder'],
        welding: ['welder-stickers-1', 'welder'],
        weld: ['welder-stickers-1', 'welder'],
        electrician: ['electrician', 'electrician-stickers'],
        carpenter: ['carpenter', 'carpenter-stickers'],
        mechanic: ['mechanic', 'mechanic-stickers'],
        hvac: ['hvac', 'hvac-stickers'],
        lineman: ['lineman', 'lineman-stickers'],
        construction: ['construction-stickers', 'construction']
      };
      var out = [];
      var seen = {};
      function add(h) {
        if (!h || seen[h]) return;
        seen[h] = 1;
        out.push(h);
      }
      (known[base] || []).forEach(add);
      add(base);
      add(base + '-stickers');
      add(base + '-stickers-1');
      if (base.endsWith('s')) add(base.slice(0, -1) + '-stickers-1');
      return out;
    }

    function fetchCollectionPage(handle, page) {
      return fetch(
        '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + (page || 1),
        { headers: { Accept: 'application/json' }, credentials: 'same-origin' }
      ).then(function (r) {
        if (!r.ok) throw new Error('collection ' + handle);
        return r.json();
      });
    }

    function collectionFallback(q, seq) {
      var handles = collectionHandleCandidates(q);
      if (!handles.length) return Promise.resolve([]);

      function tryHandle(i) {
        if (i >= handles.length) return Promise.resolve([]);
        var handle = handles[i];
        return fetchCollectionPage(handle, 1)
          .then(function (first) {
            var products = (first && first.products) || [];
            if (!products.length) return tryHandle(i + 1);
            // Shopify products.json: up to 250/page; pull more pages while full
            var chain = [Promise.resolve(first)];
            var maxPages = 8;
            for (var p = 2; p <= maxPages; p++) {
              chain.push(
                fetchCollectionPage(handle, p).catch(function () {
                  return { products: [] };
                })
              );
            }
            return Promise.all(chain).then(function (pages) {
              var all = [];
              pages.forEach(function (page) {
                ((page && page.products) || []).forEach(function (p) {
                  all.push(p);
                });
              });
              if (!all.length) return tryHandle(i + 1);
              return all;
            });
          })
          .catch(function () {
            return tryHandle(i + 1);
          });
      }

      return tryHandle(0).then(function (products) {
        if (seq !== searchSeq) return [];
        var seen = {};
        var items = [];
        products.forEach(function (p) {
          if (!p) return;
          var row = {
            title: p.title || '',
            handle: p.handle || '',
            type: p.product_type || p.type || '',
            tags: p.tags || [],
            vtitle: ''
          };
          if (isExcludedProduct(row)) return;
          var variant = pickVariant(p);
          if (!variant) return;
          var key = String(variant.id);
          if (seen[key]) return;
          seen[key] = 1;
          var img = '';
          if (typeof p.featured_image === 'string') img = p.featured_image;
          else if (p.featured_image && p.featured_image.src) img = p.featured_image.src;
          else if (p.images && p.images[0]) img = p.images[0].src || p.images[0] || '';
          items.push({
            vid: variant.id,
            title: p.title || '',
            img: img,
            handle: p.handle || '',
            search: [p.title, row.type, (p.tags || []).join(' ')].join(' ')
          });
        });
        return items;
      });
    }

    function runLiveSearch(q) {
      var seq = ++searchSeq;
      if (!q) {
        restorePool();
        return;
      }

      showEmpty(false);
      grid.setAttribute('aria-busy', 'true');

      // Pull up to 20 pages (~1000) of shop search so trade queries like welder return the full set
      fetchSearchPage(q, 1)
        .then(function (first) {
          if (seq !== searchSeq) return null;
          var pages = Math.min(Number(first.pages) || 1, 20);
          var chain = [Promise.resolve(first)];
          for (var p = 2; p <= pages; p++) chain.push(fetchSearchPage(q, p));
          return Promise.all(chain);
        })
        .then(function (pages) {
          if (seq !== searchSeq || pages == null) return;
          var items = itemsFromMpbPages(pages);
          // If theme search is thin (preview template miss / heavy filters), fill from trade collections
          if (items.length < 40) {
            return collectionFallback(q, seq).then(function (extra) {
              if (seq !== searchSeq) return;
              var seen = {};
              var merged = [];
              items.concat(extra || []).forEach(function (item) {
                if (!item || !item.vid) return;
                var key = String(item.vid);
                if (seen[key]) return;
                seen[key] = 1;
                merged.push(item);
              });
              renderSearchItems(merged, q);
            });
          }
          renderSearchItems(items, q);
        })
        .catch(function (err) {
          if (seq !== searchSeq) return;
          console.warn('[PackBuilder] search.mpb failed, trying collection then suggest', err);
          collectionFallback(q, seq).then(function (items) {
            if (seq !== searchSeq) return;
            if (items && items.length) {
              renderSearchItems(items, q);
              return;
            }
            suggestFallback(q, seq);
          });
        });
    }

    function suggestFallback(q, seq) {
      var variants = [q];
      if (window.SHSearchWords && typeof window.SHSearchWords.forms === 'function') {
        variants = window.SHSearchWords.forms(q).slice(0, 4);
      } else if (q.length >= 3 && !/s$/i.test(q)) {
        variants = [q, q + 's'];
      }
      Promise.all(
        variants.map(function (word) {
          var url =
            '/search/suggest.json?q=' +
            encodeURIComponent(word) +
            '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
          return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (r) {
              return r.ok ? r.json() : { resources: { results: { products: [] } } };
            })
            .then(function (data) {
              return ((data.resources || {}).results || {}).products || [];
            })
            .catch(function () {
              return [];
            });
        })
      ).then(function (batches) {
        if (seq !== searchSeq) return;
        var seenH = {};
        var products = [];
        batches.flat().forEach(function (p) {
          if (!p || !p.handle || seenH[p.handle]) return;
          if (isExcludedProduct(p)) return;
          seenH[p.handle] = 1;
          products.push(p);
        });
        if (!products.length) {
          grid.innerHTML = '';
          showEmpty(true, 'No single stickers match “' + q + '”. Try another word.');
          grid.removeAttribute('aria-busy');
          return;
        }
        return Promise.all(
          products.map(function (p) {
            return fetchProduct(p.handle).then(function (full) {
              var variant = pickVariant(full);
              if (!variant) return null;
              var img =
                (full && typeof full.featured_image === 'string' && full.featured_image) ||
                (p.featured_image && p.featured_image.url) ||
                p.image ||
                '';
              var row = {
                vid: variant.id,
                title: (full && full.title) || p.title || '',
                img: img,
                handle: p.handle,
                tags: (full && full.tags) || p.tags || [],
                type: (full && full.type) || p.type || ''
              };
              if (isExcludedProduct(row)) return null;
              return row;
            });
          })
        ).then(function (items) {
          if (seq !== searchSeq) return;
          var html = '';
          var n = 0;
          items.forEach(function (item) {
            if (!item || !item.vid) return;
            html += cardHtml(item);
            n++;
          });
          grid.innerHTML = html;
          if (!n) showEmpty(true, 'No single stickers match “' + q + '”. Try another word.');
          else showEmpty(false);
          syncCards();
          grid.removeAttribute('aria-busy');
        });
      });
    }


    function localFilter(q) {
      q = normalizeSearch(q);
      var tokens = q ? q.split(' ').filter(Boolean) : [];
      var visible = 0;
      grid.querySelectorAll('.mpb-card').forEach(function (card) {
        var hay = normalizeSearch(
          [
            card.getAttribute('data-search'),
            card.getAttribute('data-title'),
            card.getAttribute('data-tags'),
            card.querySelector('.mpb-card-title') && card.querySelector('.mpb-card-title').textContent
          ]
            .filter(Boolean)
            .join(' ')
        );
        var ok =
          !tokens.length ||
          tokens.every(function (t) {
            return hay.indexOf(t) !== -1;
          }) ||
          (q && hay.indexOf(q) !== -1);
        card.classList.toggle('is-hidden', !ok);
        if (ok) {
          card.removeAttribute('hidden');
          card.style.removeProperty('display');
          visible += 1;
        } else {
          card.setAttribute('hidden', '');
          card.style.display = 'none';
        }
      });
      showEmpty(tokens.length > 0 && visible === 0, 'No single stickers match that search.');
    }

    function onSearchInput() {
      if (!searchInput) return;
      var q = (searchInput.value || '').trim();
      clearTimeout(searchTimer);
      if (!q) {
        searchSeq++;
        restorePool();
        return;
      }
      searchTimer = setTimeout(function () {
        runLiveSearch(q);
      }, 220);
    }

    async function addPack() {
      try {
        if (!packVariantId || isNaN(packVariantId)) throw new Error('Pack variant is not configured.');
        if (order.length !== packLimit) throw new Error('Fill all ' + packLimit + ' slots first.');

        addBtns.forEach(function (b) {
          b.disabled = true;
        });
        setMessages('Adding pack to cart…', null);

        var chosen = order.map(function (item, i) {
          return {
            index: i + 1,
            vid: item.vid,
            title: item.title,
            img: item.img
          };
        });

        var properties = {};
        properties['Pack'] = packLimit + ' stickers';
        properties['Mix & Match Size'] = String(packLimit);
        if (priceDisplay) properties['Pack Price'] = priceDisplay;
        properties['_pack_thumbs'] = chosen
          .map(function (c) {
            return String(c.img || '').replace(/,/g, '%2C');
          })
          .join(',');
        properties['_pack_titles'] = chosen
          .map(function (c) {
            return String(c.title || '')
              .replace(/\s+/g, ' ')
              .trim()
              .replace(/,/g, '‚');
          })
          .join(',');
        properties['_pack_vids'] = chosen
          .map(function (c) {
            return String(c.vid);
          })
          .join(',');

        var payload = {
          items: [
            {
              id: packVariantId,
              quantity: 1,
              properties: properties
            }
          ]
        };

        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!res.ok) {
          var t = await res.text();
          throw new Error(t || 'Add to cart failed');
        }

        setMessages('Pack added!', 'is-ok');
        if (window.StickerheadsCart && typeof window.StickerheadsCart.open === 'function') {
          window.StickerheadsCart.open();
        } else {
          var openBtn = document.querySelector('[data-sh-cart-open]');
          if (openBtn) openBtn.click();
          else {
            var pt = new URLSearchParams(location.search).get('preview_theme_id');
            location.href = '/cart' + (pt ? '?preview_theme_id=' + encodeURIComponent(pt) : '');
          }
        }
      } catch (err) {
        console.error('[PackBuilder]', err);
        setMessages('Error: ' + (err && err.message ? err.message : err), 'is-error');
        syncButtonState();
      }
    }

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.mpb-select-btn');
      var media = e.target.closest('.mpb-card-media');
      var card = e.target.closest('.mpb-card');
      if (!card || (!btn && !media)) return;
      e.preventDefault();
      e.stopPropagation();
      addFromCard(card);
    });

    function slotFromEvent(e, sel) {
      return e.target.closest(sel);
    }

    function onFilledSlotActivate(e) {
      var slot = slotFromEvent(e, '.mpb-slot.is-filled[data-uid], .mpb-dock-slot.is-filled[data-uid]');
      if (!slot) return;
      e.preventDefault();
      removeUid(slot.getAttribute('data-uid'));
    }

    function onFilledSlotKey(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var slot = slotFromEvent(e, '.mpb-slot.is-filled[data-uid], .mpb-dock-slot.is-filled[data-uid]');
      if (!slot) return;
      e.preventDefault();
      removeUid(slot.getAttribute('data-uid'));
    }

    slotsEl.addEventListener('click', onFilledSlotActivate);
    slotsEl.addEventListener('keydown', onFilledSlotKey);
    if (dockSlotsEl) {
      dockSlotsEl.addEventListener('click', onFilledSlotActivate);
      dockSlotsEl.addEventListener('keydown', onFilledSlotKey);
    }

    if (searchInput) {
      searchInput.setAttribute('autocomplete', 'off');
      searchInput.setAttribute('name', 'mpb_q_' + Date.now());
      searchInput.setAttribute('data-mpb-search', '1');
      searchInput.setAttribute('type', 'search');
      // Block theme/header search hijacks
      ['input', 'keyup', 'keydown', 'keypress', 'change', 'search', 'paste', 'focus'].forEach(function (ev) {
        searchInput.addEventListener(
          ev,
          function (e) {
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            if (ev === 'keydown' && e.key === 'Enter') e.preventDefault();
            if (ev === 'input' || ev === 'keyup' || ev === 'change' || ev === 'search' || ev === 'paste') {
              onSearchInput();
            }
          },
          true
        );
      });
      root.addEventListener(
        'submit',
        function (e) {
          if (e.target && (e.target === searchInput || (e.target.contains && e.target.contains(searchInput)))) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    }

    if (packSizeSel) {
      packSizeSel.addEventListener('change', function (e) {
        applySize(e.target.value);
      });
    }
    addBtns.forEach(function (btn) {
      btn.addEventListener('click', addPack);
    });
    syncHint();

    // Drop packs/bulk/customs from the starter pool grid
    grid.querySelectorAll('.mpb-card').forEach(function (card) {
      var title = card.getAttribute('data-title') || '';
      var search = card.getAttribute('data-search') || '';
      var tags = card.getAttribute('data-tags') || '';
      if (
        isExcludedProduct({
          title: title + ' ' + search,
          handle: title.toLowerCase().replace(/\s+/g, '-'),
          tags: String(tags).split(/[\s,]+/).filter(Boolean),
          type: ''
        })
      ) {
        card.remove();
      }
    });
    poolHtml = grid.innerHTML;

    var startSize = packSizeSel ? packSizeSel.value : defaultPack;
    applySize(startSize);
    syncCards();
  });
})();